import { Routes, Route } from 'react-router-dom';
import Home from './pages/public/Home';
import OffersPage from './pages/public/OffersPage';
import OfferDetail from './pages/public/OfferDetail';
import RestaurantPage from './pages/public/RestaurantPage';
import Login from './pages/admin/Login';
import Dashboard from './pages/admin/Dashboard';
import OffersManagement from './pages/admin/OffersManagement';
import RestaurantsManagement from './pages/admin/RestaurantsManagement';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/" element={<Home />} />
      <Route path="/offers" element={<OffersPage />} />
      <Route path="/offers/:id" element={<OfferDetail />} />
      <Route path="/restaurants/:id" element={<RestaurantPage />} />

      {/* Admin Routes */}
      <Route path="/admin/login" element={<Login />} />
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/offers"
        element={
          <ProtectedRoute>
            <OffersManagement />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/restaurants"
        element={
          <ProtectedRoute>
            <RestaurantsManagement />
          </ProtectedRoute>
        }
      />

      {/* 404 */}
      <Route path="*" element={<div className="p-8 text-center">Page Not Found</div>} />
    </Routes>
  );
}

export default App;
